import { ReactElement } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import AccountDetails from 'account-details-mfe'
import config from 'const/config'
import featureFlags from 'const/featureFlags'
import { accountDetailsModalContainerId } from 'const/modalContainerId'
import { getLanguageFromStorage } from 'helpers'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { MFEConfig } from 'syf-js-utilities/typings/mfeConfig'
import findAccount from 'helpers/findAccount'
import { useAccountSummary, useCreditAccounts } from 'const/syfApiQueries'
import getHelpNumber from 'helpers/getHelpNumbers'
import { triggerOnCloseAnalytics } from 'helpers/triggerOnCloseAnalytics'
import { useNavigate } from 'react-router-dom'
import routes from 'const/routes'
import Loader from 'authorization-module/lib/ui/atoms/Loader'

const DetailsModal = (): ReactElement => {
  const [{ modalTriggerId, modalId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const { data: { accounts = [] } = {} } = useCreditAccounts()
  const { data: accountSummary, isLoading: isAccountSummaryLoading } =
    useAccountSummary(selectedAccount)

  const navigate = useNavigate()

  const account = findAccount(accounts, selectedAccount)
  const isRegistered = account?.registration?.registered
  const clientId = accountSummary?.product?.clientId
  const { type: productType } = account?.product || {}
  const helpNumber = getHelpNumber(clientId, productType)

  const accountDetailsConfig: MFEConfig = {
    hosts: {
      apigee: new URL(config.API_HOST),
      assets: new URL(config.ASSETS_HOST)
    },
    apiErrorCallback: (err) => err,
    lang: getLanguageFromStorage()
  }

  const handleCloseModal = () => {
    if (modalTriggerId && document.getElementById(modalTriggerId)) {
      document.getElementById(modalTriggerId).focus()
    }
    triggerOnCloseAnalytics()
    if (featureFlags.isAccountDetailsRouteEnabled) {
      navigate(routes.HOME)
    } else {
      updateModalStatus('', '')
    }
  }

  if (featureFlags.isAccountDetailsRouteEnabled && isAccountSummaryLoading) {
    return <Loader />
  }

  return (
    <AccountDetails
      containerId={accountDetailsModalContainerId()}
      config={accountDetailsConfig}
      isModalOpen={
        featureFlags.isAccountDetailsRouteEnabled || modalId === 'Details'
      }
      handleClose={handleCloseModal}
      selectedAccountId={selectedAccount}
      triggerAnalyticsEvent={triggerAnalyticsEvent}
      featureFlags={{
        isNotificationsEnabled: featureFlags.isNotificationsEnabled,
        isIRLEnabled: featureFlags.isIRLEnabled
      }}
      isRegistered={isRegistered}
      helpNumber={helpNumber}
    />
  )
}

export default DetailsModal
